export default __webpack_public_path__ + "static/media/refresh.22824050.png";